import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8082/api';

const api = axios.create({
  baseURL: API_URL,
});

// Ajoute le token JWT automatiquement (admin ou client)
api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem('token');
  const clientToken = localStorage.getItem('clientToken');
  const isClientRoute = config.url?.includes('/client/');
  const token = isClientRoute
    ? (clientToken || adminToken)
    : (adminToken || clientToken);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Véhicules publics
export const getVehiclesPublic = () => api.get('/vehicles/public');
export const getVehicleById = (id) => api.get(`/vehicles/public/${id}`);

// Config du site
export const getSiteConfig = () => api.get('/config/public');

// Auth admin
export const login = (username, password) =>
  api.post('/auth/login', { username, password });
export const getTeamMembers = () => api.get('/team/public');

// Auth client
export const registerClient = (data) => api.post('/client/auth/register', data);
export const loginClient = (data) => api.post('/client/auth/login', data);
export const verifyEmail = (token) => api.get(`/client/auth/verify-email?token=${token}`);
export const forgotPassword = (email) => api.post('/client/auth/forgot-password', { email });
export const resetPassword = (data) => api.post('/client/auth/reset-password', data);
export const getMe = () => api.get('/client/auth/me');

// Favoris
export const getFavorites = () => api.get('/client/favorites');
export const getFavoriteIds = () => api.get('/client/favorites/ids');
export const toggleFavorite = (vehicleId) => api.post(`/client/favorites/toggle/${vehicleId}`);

export default api;
